// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3pmFk","bigColWidth":"Table_bigColWidth__2C9gZ","biggerColWidth":"Table_biggerColWidth___C9dJ","row":"Table_row__yXZD_","col":"Table_col__2vxgD"};